import { ICrudLocale } from '@app/i18n/interface';

export const MARKUP_MANAGEMENT_LOCALE_ES: ICrudLocale = {
  MARKUP: {
    LABEL: {
      SINGULAR: 'Margen',
      PLURAL: 'Márgenes',
    },
    FORM: {
      ADD_TITLE: 'Añadir margen',
      EDIT_TITLE: 'Cambiar margen',
      CARD_TITLE: 'Datos del margen',
      BACK: 'Volver a Márgenes',
      ADD_DESCRIPTION: 'Define un margen que se suma al precio neto de Hotelbeds.',
      EDIT_DESCRIPTION: 'Cambia el valor, el alcance o la vigencia de este margen.',
      FETCH_ERROR: 'No hemos podido cargar el margen. Vuelve a intentarlo.',
    },
    NOTE: {
      TITLE: 'Cómo se aplica',
      BODY: 'Se aplica la regla más específica (destino, proveedor, vertical y, por último, global); a igual alcance, la de mayor prioridad. Si ninguna aplica, no se suma margen: deja siempre una regla global activa.',
    },
    PAGE: {
      DESCRIPTION:
        'Define cuánto se suma al precio neto de Hotelbeds y comprueba cómo queda el precio final de una tarifa.',
      ADD: 'Añadir margen',
    },
    RULE: {
      TITLE: 'Cómo se calcula el precio de venta',
      STEP_1: 'Partimos del precio neto que devuelve Hotelbeds.',
      STEP_2: 'Sumamos el margen. Por defecto es de 15 a 20 % sobre el neto.',
      STEP_3: 'Si neto más margen queda por debajo del RSP, el precio sube hasta el RSP.',
      STEP_4: 'Si Hotelbeds marca la tarifa con precio obligatorio, usamos el RSP tal cual.',
      RESULT: 'El precio de venta nunca es menor que el RSP, el precio de venta recomendado por Hotelbeds.',
    },
    EXAMPLE: {
      TITLE: 'Ejemplo con una tarifa',
      SUBTITLE: '2 noches, 2 adultos',
      NET: 'Neto de Hotelbeds',
      MARKUP: 'Margen del {{pct}} % sobre el neto',
      NET_PLUS: 'Neto más margen',
      RSP: 'RSP de Hotelbeds',
      FINAL: 'Precio de venta final',
      NOTE: '{{netPlus}} queda por debajo del RSP, así que el precio sube a {{rsp}}. Con un RSP de {{lowRsp}}, el precio final sería {{netPlus}}.',
      RAW_HINT: 'Textos del proveedor, tal como llegan',
    },
    FX: {
      TITLE: 'Tipo de cambio de referencia',
      SOURCE: 'Fuente',
      SOURCE_ECB: 'Banco Central Europeo (BCE), tipos de referencia',
      LAST_RATE: 'Último tipo publicado',
      UPDATED: 'Última actualización',
      NONE: 'Todavía no hay ningún tipo de cambio activo.',
      NOTE: 'Se actualiza solo cada día laborable. Uso pendiente de definir. Los cargos pagaderos en el alojamiento conservan su divisa.',
      MANAGE: 'Ver los tipos de cambio',
    },
    HELP: {
      TITLE: 'Qué significa cada término',
      MARKUP_TITLE: 'Margen',
      MARKUP_BODY: 'Es el porcentaje que IBSOA suma al precio neto de Hotelbeds. Por defecto va de 15 a 20 %.',
      RSP_TITLE: 'RSP',
      RSP_BODY: 'Es el precio de venta que Hotelbeds recomienda. IBSOA no vende por debajo de él.',
      FX_TITLE: 'Tipo de cambio',
      FX_BODY: 'Fuente: BCE, cada día laborable. Uso pendiente de definir.',
    },
    VALIDITY: {
      ALWAYS: 'Siempre',
      FROM: 'Desde el {{date}}',
      UNTIL: 'Hasta el {{date}}',
    },
    FLOOR: {
      TITLE: 'Suelo del proveedor · últimos {{days}} días',
      BODY: 'de las {{priced}} tarifas mostradas se vendieron al precio recomendado ({{floor}}).',
      HINT: 'En esa parte del catálogo el margen lo marca el proveedor, no tu regla.',
      SEARCHES_ONE: 'Medido en 1 búsqueda.',
      SEARCHES: 'Medido en {{searches}} búsquedas.',
      NO_DATA: 'Todavía no hay búsquedas medidas en esta ventana.',
    },
    FIELD: {
      NAME: 'Nombre',
      SCOPE: 'Alcance',
      VERTICAL: 'Vertical',
      PROVIDER_CODE: 'Código de proveedor',
      DESTINATION: 'Destino',
      TYPE: 'Tipo',
      VALUE: 'Margen sobre el neto',
      VALUE_PERCENTAGE: 'Porcentaje (%)',
      VALUE_FIXED: 'Importe fijo',
      PRIORITY: 'Prioridad',
      ACTIVE: 'Activa',
      STATE: 'Estado',
      UPDATED: 'Última modificación',
      VALID_FROM: 'Válida desde',
      VALID_TO: 'Válida hasta',
      VALIDITY: 'Vigencia',
    },
    SCOPE: {
      GLOBAL: 'Global',
      PROVIDER: 'Proveedor',
      DESTINATION: 'Destino',
      VERTICAL: 'Vertical',
    },
    TYPE: {
      PERCENTAGE: 'Porcentaje',
      FIXED: 'Importe fijo',
    },
    VERTICAL_OPTION: {
      HOTEL: 'Hotel',
      FLIGHT: 'Vuelo',
      TRANSFER: 'Traslado',
      CRUISE: 'Crucero',
    },
    VALIDATION: {
      VALUE_PATTERN: 'Escribe un decimal no negativo (máximo 4 decimales).',
      VALUE_PERCENTAGE_MAX:
        'El porcentaje no puede superar {{ max }} (validación del servidor).',
      DATE_RANGE: '«Válida desde» tiene que ser anterior a «Válida hasta».',
    },
    LIST: {
      TITLE: 'Reglas de margen',
      CAPTION: 'Márgenes, su alcance, vigencia y última modificación',
      EMPTY: 'Todavía no hay ninguna regla de margen: hoy no se suma margen a ninguna tarifa.',
      ACTIVE: 'Activa',
      INACTIVE: 'Desactivada',
      UPDATED: 'Última modificación',
      CHANGE: 'Cambiar margen',
      CHANGE_ARIA: 'Cambiar el margen {{name}}',
      DISABLE: 'Desactivar',
      DISABLE_ARIA: 'Desactivar el margen {{name}}',
      ENABLE: 'Activar',
      ENABLE_ARIA: 'Activar el margen {{name}}',
      REMOVE: 'Quitar',
      REMOVE_ARIA: 'Quitar el margen {{name}}',
      TOGGLE_ERROR: 'No hemos podido cambiar el margen. Vuelve a intentarlo.',
    },
    REMOVE: {
      TITLE: '¿Quitar el margen {{name}}?',
      BODY: 'Deja de aplicarse a las tarifas y no se puede deshacer desde aquí.',
      HINT: 'Si solo quieres pausarlo, desactívalo.',
      KEEP: 'Mantener el margen',
      CONFIRM: 'Quitar margen',
      DONE: 'El margen {{name}} se ha quitado.',
      ERROR: 'No hemos podido quitar el margen {{name}}. Vuelve a intentarlo.',
    },
  },
};
